import Resource from '@/api/resources/Resource'
import { extend } from 'lodash'
import { commonCaseReportModel, IParamsMultipleAPR, IParamsPreviousAPRCase, IParamsPreviousAPRPatient } from './commonCaseReportServices.models'

class CommonCaseReportServices extends Resource {
    async getPreviousAPRPatient(params: IParamsPreviousAPRPatient, headers?: any): Promise<commonCaseReportModel> {
        const extendedParams: any = extend({}, { params }, headers)
        const response = await this.axios.get(`/common/cases/reports`, extendedParams)
        return response.data
    }

    async getAPRCase(params: IParamsPreviousAPRCase): Promise<commonCaseReportModel> {
        const response = await this.axios.get(`/common/laboratories/${params.laboratoryId}/cases/${params.casId}/reports`)
        return response.data
    }

    async getMultipleAPR(params: IParamsMultipleAPR): Promise<commonCaseReportModel> {
        const response = await this.axios.get(`/common/laboratories/${params.laboratoryId}/cases/reports`)
        return response.data
    }
}

export const commonCaseReportServices = new CommonCaseReportServices()
